import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Divider from '../../../divider/Divider';
import { useTheme } from '../../../theme-context';

interface ITicketBoughtManageOrderLine {
    manageOrderUrl: string;
}

const TicketBoughtManageOrderLine = ({
    manageOrderUrl,
}: ITicketBoughtManageOrderLine): React.ReactElement => {
    const { getFont } = useTheme();

    return (
        <div>
            <Divider />
            <div
                className={css({
                    margin: '16px 16px 0px',
                    fontFamily: getFont('desktop/body/medium/bold').fontFamily,
                    fontWeight: getFont('desktop/body/medium/bold').fontWeight,
                    fontSize: getFont('desktop/body/medium/bold').fontSize,
                })}
            >
                <a
                    href={manageOrderUrl}
                    className="eds-link"
                    data-testid="manage-order"
                >
                    {gettext('Manage order')}
                </a>
            </div>
        </div>
    );
};

export default TicketBoughtManageOrderLine;
